import styled from '@emotion/styled';
import React,{useState} from 'react'
import { useSettingModal } from '../../../../hooks/Context';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from './CreateAdminUser';
import apiCall from '../../../../utils/apiCall';



const StyledForm = styled.form`
    background-color  :#fff ;
    display:flex;
    flex-direction: column;
    gap:20px;
    padding:20px 30px; 
     & > *{
        width:100%;
     }
`;


const StyledLabel = styled.label`
    display: flex;
    flex-direction: column;
    gap:10px;
`

const StyledInput = styled.input`
    padding:15px;
    border:1px solid #E1E1E1;
    outline:none;
    border-radius: 5px;
`


const CreateSpecialisation = () => {
    const {setShowModal} = useSettingModal()
    const [SpecialisationName,setName] = useState<string>('');
    const [SpecialisationValue,setSpecialisationValue] = useState<string>('');
    
    const handleSubmit =(e:any)=>{
        e.preventDefault();
        if(SpecialisationName && SpecialisationValue){
            const apiData = {
                Id:Math.floor(Math.random() * 1000)+1,
                SpecialisationName:SpecialisationName,
                SpecialisationValue:SpecialisationValue
            }
         
            apiCall().post(`/api/SetUp/CreateSpecialization`, apiData)
            .then(data =>{
               
            })
            .catch(err =>{
             
            })
        }
    }
  return (
    <ModalContainer>
         <div>
            <div>
            <div>
                <IconContainer><UIcon /></IconContainer>
                <span>Create  Specialisations</span>
            </div>
            </div>
            <StyledForm onSubmit={handleSubmit}>
                <StyledLabel>
                    <span>Specialisation Name</span>
                    <StyledInput value={SpecialisationName}
                    onChange={(e)=>setSpecialisationValue(e.target.value)}
                     type="text" placeholder='Specialisation Name' />
                </StyledLabel>
                <StyledLabel>
                    <span>Score</span>
                    <StyledInput value={SpecialisationValue}
                    onChange={(e)=>setSpecialisationValue(e.target.value)}
                     type="text" placeholder='Score' />
                </StyledLabel>
                <SubmitContainer>
                    <span onClick={()=>setShowModal(false)}>Cancel</span>
                    <StyleButton>Submit</StyleButton>
                </SubmitContainer>
            </StyledForm>
        </div>
    </ModalContainer>
  )
}

export default CreateSpecialisation